import { useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { publish, useSubscribe } from "./Messages";

const useHybridTokenImpl = () => {
  const [hybridToken, setHybridToken] = useState("");

  if (!hybridToken) publish.queryAuthToken();
  useSubscribe((message) => {
    if (message.type === "EVENT:AUTH_TOKEN") {
      setHybridToken(message.payload.token);
    }
  });
  useSubscribe((message) => {
    if (message.type === "COMMAND:LOGOUT") {
      setHybridToken("");
    }
  });

  return hybridToken;
};

const useHybridToken = singletonHook("", useHybridTokenImpl);

export { useHybridToken };
